import { isSupportMessage } from "./supportMessages.ts";
import type { SupportMessage } from "./supportMessages.ts";

export interface CustomerCareFields {
  customerCareChatId: string | null;
  customerCareMessages: SupportMessage[];
}

export const customerCareStorageKey = (role: "user" | "vendor", accountId: string) =>
  `mbaay:customer-care:${role}:${accountId}:chatId`;

const record = (value: unknown): Record<string, unknown> | null =>
  value !== null && typeof value === "object" && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;

// The previous role-slice chatId/messages were written exclusively by Customer
// Care. Move that known state once; marketplace state never reads these fields.
export function migrateCustomerCareFields(value: unknown): Record<string, unknown> & CustomerCareFields {
  const slice = record(value) ?? {};
  const next = { ...slice };
  const storedId = Object.prototype.hasOwnProperty.call(slice, "customerCareChatId") ? slice.customerCareChatId : slice.chatId;
  const storedMessages = Object.prototype.hasOwnProperty.call(slice, "customerCareMessages") ? slice.customerCareMessages : slice.messages;
  delete next.chatId;
  delete next.messages;
  return {
    ...next,
    customerCareChatId: typeof storedId === "string" && storedId.trim() && storedId !== "undefined" && storedId !== "null" ? storedId : null,
    customerCareMessages: Array.isArray(storedMessages) ? storedMessages.filter(isSupportMessage) : [],
  };
}

export function migratePersistedCustomerCareState<T>(value: T): T {
  const state = record(value);
  if (!state) return value;
  return {
    ...state,
    ...(record(state.user) ? { user: migrateCustomerCareFields(state.user) } : {}),
    ...(record(state.vendor) ? { vendor: migrateCustomerCareFields(state.vendor) } : {}),
  } as T;
}
